import axios from "../../../services/axios-config";

export async function deleteCompany({ companyId }) {
    const res = await axios.delete(`/admin/companies/${companyId}`);
    return res?.data;
}
